import { render, staticRenderFns } from "./RequestNewToken.vue?vue&type=template&id=6a185b2d&scoped=true"
import script from "./RequestNewToken.vue?vue&type=script&lang=js"
export * from "./RequestNewToken.vue?vue&type=script&lang=js"
import style0 from "./RequestNewToken.vue?vue&type=style&index=0&id=6a185b2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a185b2d",
  null
  
)

export default component.exports